import React from 'react';
import { Input, Label } from 'reactstrap';
import LoginFieldError from '../LoginFieldError';

// Input kode verifikasi (email / authenticator / recovery code) dengan gaya form login.
const CodeField = ({
  id,
  label,
  value,
  onChange,
  error,
  icon = 'ri-shield-keyhole-line',
  numeric = true,
  maxLength = 6,
  placeholder = 'Enter the 6-digit code',
  autoFocus = false,
}) => (
  <div className='mb-3'>
    <Label htmlFor={id} className='login-label'>
      {label}
    </Label>
    <div className='input-group login-input-group'>
      <span className='input-group-text'>
        <i className={icon} aria-hidden='true' />
      </span>
      <Input
        id={id}
        name={id}
        className='form-control mfa-code-input'
        value={value}
        onChange={e =>
          onChange(
            numeric
              ? e.target.value.replace(/\D/g, '').slice(0, maxLength)
              : e.target.value.slice(0, maxLength)
          )
        }
        placeholder={placeholder}
        inputMode={numeric ? 'numeric' : 'text'}
        autoComplete='one-time-code'
        maxLength={maxLength}
        autoFocus={autoFocus}
        aria-required='true'
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? `${id}-error` : undefined}
        invalid={!!error}
      />
    </div>
    <LoginFieldError id={`${id}-error`} message={error} />
  </div>
);

export default CodeField;
